import { User, Shield, Briefcase, Calculator, Headphones } from 'lucide-react';

export const getRoleIcon = (role) => {
  switch (role) {
    case 'admin': return <Shield className="w-4 h-4 text-purple-500" />;
    case 'manager': return <Shield className="w-4 h-4 text-indigo-500" />;
    case 'customer_service': return <Headphones className="w-4 h-4 text-teal-500" />;
    case 'accountant': return <Calculator className="w-4 h-4 text-emerald-500" />;
    case 'provider': return <Briefcase className="w-4 h-4 text-blue-500" />;
    default: return <User className="w-4 h-4 text-slate-400" />;
  }
};

export const getRoleBadge = (role) => {
  const colors = {
    admin: 'bg-purple-100 text-purple-700',
    manager: 'bg-indigo-100 text-indigo-700',
    customer_service: 'bg-teal-100 text-teal-700',
    accountant: 'bg-emerald-100 text-emerald-700',
    provider: 'bg-blue-100 text-blue-700',
    customer: 'bg-stone-100 text-stone-600'
  };
  return colors[role] || colors.customer;
};

export const formatRoleName = (role) => {
  const names = { 
    customer_service: 'Customer Service', 
    accountant: 'Accountant' 
  };
  return names[role] || role.charAt(0).toUpperCase() + role.slice(1);
};

export const isStaffRole = (role) => ['manager', 'customer_service', 'accountant'].includes(role);

export const roleColors = {
  admin: 'bg-purple-100 text-purple-600',
  manager: 'bg-indigo-100 text-indigo-600',
  customer_service: 'bg-teal-100 text-teal-600',
  accountant: 'bg-emerald-100 text-emerald-600',
  provider: 'bg-blue-100 text-blue-600',
  customer: 'bg-green-100 text-green-600',
  all: 'bg-slate-100 text-slate-600'
};
